<div class="slideout-content">
    <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new-user modal-content pt-0">
                <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        (click)="toggleSidebar()"
                >
                    ×
                </button>
                <div class="modal-header">
                    <h5 class="modal-title" *ngIf="!data || !data['id']">Add Mapping</h5>
                    <h5 class="modal-title" *ngIf="data && data['id']">Update Mapping</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <form class="form mt-2 shadow-none" novalidate [formGroup]="addSRMappingForm">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="stage_id">Stage</label>
                                        <select class="form-control" id="stage_id" formControlName="stage_id">
                                            <option value="">Select Stage</option>
                                            <option [value]="stage.id" *ngFor="let stage of stages">{{stage?.name}}</option>
                                        </select>
                                        <small *ngIf="submitted && addSRMappingForm.get('stage_id').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="reason_id">Reason</label>
                                        <select class="form-control" id="reason_id" formControlName="reason_id">
                                            <option value="">Select Reason</option>
                                            <option [value]="reason.id" *ngFor="let reason of reasons">{{reason?.name}}</option>
                                        </select>
                                        <small *ngIf="submitted && addSRMappingForm.get('reason_id').hasError('required')"
                                               class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <button type="button" rippleEffect  class="btn btn-danger" data-dismiss="modal" aria-label="Close" (click)="toggleSidebar()">
                                        Cancel
                                    </button>
                                    <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                            (click)="submit()" *ngIf="!data || !data['id']">Submit
                                    </button>
                                    <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                            (click)="update()" *ngIf="data && data['id']">Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </form>
        </div>
    </div>
    <!-- Modal to add new user Ends-->
</div>


